<template>
  <div class="hello">
    <div id="pdfdoc" ref='content'>
      <div>
        <div class="F1" v-if="showheader">
          <img src="../assets/logo2laason2.png" />
          <div class="F1B2">
            <h3>Laboratorio de Alimentos y Aguas de Sonora, S.A. de C.V.</h3>
            <h4>LABORATORIO DE ENSAYOS ACREDITADO ISO/IEC 17025:2017</h4>
            <p>Garmendia N°80, Col.San Benito C.P. 83190 Hermosillo, Sonora.</p>
          </div>
        </div>

        <template>
          <div v-html="contenido" style="padding: 0vw 5vw;">

          </div>
        </template>

      </div>
    </div>
    <img id="ipr" src="../assets/gruplarg.jpg">



    <div class="F12">
      <p @click="wait()" class="btnRegresar5">Regresar</p>
      <button class="DButton" @click="downloadWithCSSempty(true), showheader = true">Descargar</button>
    </div>

    <div style="margin-left: 5vw; margin-top: 5vw;">
      <label for="descr">Contenido</label>
      <VueEditor id="vueEditor" placeholder="Preparación" class="vue__editor"
      :editor-toolbar="customToolbar" v-model="contenido" />
    </div>


    <div class="F12">
      <p @click="id= null, contenido =''" class="btnRegresar5">Cancelar</p>
      <button class="DButton" @click="save(contenido)">Guardar</button>
    </div>

    <div v-if="status !== ''" class="status_messages">
      <div v-if="status === 'success'" class="msg msg_success">
        <p>{{ message }}</p>
      </div>
      <div v-if="status === 'error'" class="msg msg_error">
        <p>{{ message }}</p>
      </div>
    </div>

    <div v-for="(item, index) in declaraciones" :key="index" style="width: 90%">
      <div style="display: flex; gap: 1vw; border-bottom: 1px solid #ccc; cursor: pointer;" >
        <p @click="id= item.id, contenido= item.contenido" v-html="item.contenido" style="width: 80%; max-height: 7vw; overflow: auto;"></p> 
        <p style="font-weight: 700;">{{ item.created_at  | format}}</p>
        <p @click="id = item.id, viewModal=true"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M4 7H20H4ZM16 7V4C16 3.73478 15.8946 3.48043 15.7071 3.29289C15.5196 3.10536 15.2652 3 15 3H9C8.73478 3 8.48043 3.10536 8.29289 3.29289C8.10536 3.48043 8 3.73478 8 4V7H16ZM18 20V7H6V20C6 20.2652 6.10536 20.5196 6.29289 20.7071C6.48043 20.8946 6.73478 21 7 21H17C17.2652 21 17.5196 20.8946 17.7071 20.7071C17.8946 20.5196 18 20.2652 18 20Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg></p>
      </div>
    </div>


    <div v-if="regLoading" class="loaderView">
      <div>
        <div class="loaderSpinner"></div>
        <p class="process">{{ process }}</p>
      </div>
    </div>

    <div v-if="viewModal" class="modal_view">
        
        <div id="modal_delete">
        <p @click="id =null, viewModal = false" class="close_modal"> &#215;</p>
        <h3 class="title_modal">Eliminar</h3>
        <p class="message_modal">¿Estás seguro que deseas eliminar este registro?</p>
        <div class="modal_btns dflx">
            <p @click="id =null, viewModal = false" class="cancelar">cancelar</p> <p  @click="eliminar()" class="eliminar">eliminar</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import html2PDF from "html2pdf.js";
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import canvas from 'canvas';
import { mapActions } from 'vuex';
import dayjs from "dayjs";
import { VueEditor } from "vue2-editor";

export default {
  name: 'PDFBlanco',
  components: {
        VueEditor
  },
  data() {
    return {
      status: '',
      message: '',
      viewModal: false,
      altura: 0,
      conteo: 0,

      showheader: true,
      totalPages: 1,
      emptyPDF: true,

      regLoading: false,
      process: '',
      id: null,
      contenido:null,

      customToolbar: [
        ["bold", "italic", "underline", "strike"], 
        ["blockquote", "code-block"],

        [{ header: 1 }, { header: 2 }], 
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }], 
        [{ direction: "rtl" }], 

        [{ size: ["small", false, "large", "huge"] }], 
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [ 'image' ], 
        ["link"], 
        [{ color: [] }, { background: [] }], 
        [{ font: [] }],
        [{ align: [] }],
        ["clean"],
      ],

    }
  },
  async created() {
    await this.getIdentity()
    
    await this.actualizar()
  },
  computed: {
    declaraciones() {
      const data = this.$store.getters['declaraciones/data'];
      return Array.isArray(data) ? data : []
    },
    identity() {
      return this.$store.getters['admin/getIdentity'];
    },
  },
  methods: {
    ...mapActions('declaraciones', ['getAllInfoDcl', 'addItemDcl' ,'editItemDcl']),
    
    wait: function () {
      setTimeout(() => this.$router.go(), 200);
    },

    getIdentity: async function () {
      let response = await this.$store.dispatch("admin/getData");
      return response
    },

    async eliminar(){
        this.status='';
        this.message='';
        this.viewModal = false

        this.regLoading = true
        const  result = await this.$store.dispatch("declaraciones/deleteItemDcl", {option: 'declaraciones', id: this.id});
        this.regLoading = false 

        this.actualizar()

        if(result.status !== 'success'){
          this.message = result.message;
          this.status='error'
          this.delStatus(false);
        }

        this.id = null
    },
    async save(contenido){
      this.regLoading = true
      let response = null

      if(!this.id){
        response =  await this.addItemDcl({
          option:'declaraciones',
          item: { contenido }
        })
      }else{
        response =  await this.editItemDcl({
          option:'declaraciones',
          item: { id: this.id , contenido}
        })
      }
      
      this.regLoading = false

      this.actualizar()

      if(response.status !== 'success'){
        this.status = 'error'
        this.message = response.message
        this.delStatus(false);
        return
      }

      this.id = null,
      this.contenido = ''
    },

    async actualizar(){
      this.regLoading = true
      await this.getAllInfoDcl('declaraciones')
      this.regLoading = false
    },

    async downloadWithCSSempty(HoldHeader) {
      this.emptyPDF = true
      let clalason = `TEST`

      this.showheader = HoldHeader
      const pages = document.getElementById('pdfdoc');

      let sheight = screen.height * 1.4, swidth = screen.width * 1.3;

      var opt
      let margintop = 5
      if (!HoldHeader) margintop = 26
      opt = {
        margin: [(sheight * margintop) / 100, 30, (sheight * 15) / 100, 30],
        filename: `Documento.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'px', format: [pages.getBoundingClientRect().width, pages.getBoundingClientRect().width * 1.29], orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
      };


      await html2PDF().set(opt).from(pages).toPdf().get('pdf').then(async function (pdf) {

        var totalPages = pdf.internal.getNumberOfPages();

        function getBase64Image(img) {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL();
          return dataURL;
        }

        var base64 = getBase64Image(document.getElementById("ipr"));

        for (let i = 1; i <= totalPages; i++) {

          pdf.setPage(i);
          if (HoldHeader) {
            pdf.addImage(base64, 'PNG', 32, (pages.getBoundingClientRect().width * 1.29) * .89, pages.getBoundingClientRect().width * .94, (pages.getBoundingClientRect().width * 1.29) * .08, { baseline: 'bottom' }, 'SLOW');
          }
          //REV-01 FA-18
          pdf.setFontSize((swidth * 0.7) / 100)
          pdf.setTextColor(86, 86, 86);
          pdf.text(pages.getBoundingClientRect().width / 30, (pdf.internal.pageSize.getWidth() / 2.25, (pdf.internal.pageSize.getHeight() - 38)), `REV-01`);
          pdf.text(pages.getBoundingClientRect().width * 0.93, (pdf.internal.pageSize.getWidth() / 2.25, (pdf.internal.pageSize.getHeight() - 38)), `FA-18`);
          pdf.text(pages.getBoundingClientRect().width * 0.9, (pdf.internal.pageSize.getWidth() / 2.25, (pdf.internal.pageSize.getHeight() - 8)), `Hoja ${i} de ${totalPages}`);

        }
      }).save();
      this.emptyPDF = false
    },



    delStatus: function (reload = true) {
      setTimeout(() => this.delMsgs()
        , 2000);
      if (reload) {
        setTimeout(() => this.wait()
          , 500);
      }

    },
    delMsgs: function () {
      this.status = ""
      this.message = ""
    },


  },
  filters:{
    format(value){
      return dayjs(value).format('DD/MM/YYYY')
    }
  }
}

</script>


<style scoped>
.hello{
  padding-bottom: 5vw;
}
.vue__editor {
    width: 60vw;
}

.vue__editor>>>.ql-toolbar.ql-snow {
  
    border-radius: .3125rem .3125rem 0 0 !important;
    border-color: #DBDBDB;
}

.vue__editor>>>.quillWrapper .ql-snow.ql-toolbar .ql-formats {
    margin-bottom: 0 !important;
}

.vue__editor>>>.ql-toolbar.ql-snow .ql-formats {
    margin-right: 0 !important;
}

.vue__editor>>>.ql-toolbar.ql-snow+.ql-container.ql-snow {
    border-radius: 0 0 .3125rem .3125rem;
    border-color: #DBDBDB;
}

.vue__editor>>>.ql-editor {
    min-height: 19.375rem;
    height: auto;
    color: #323232 !important;
    font-family: "DM Sans" !important;
    line-height: normal !important;
    padding: .4375rem .625rem !important;
    border-color: #929292;
}

.vue__editor>>>.ql-editor.ql-blank::before {
    font-weight: 300 !important;
}

.F1 {
  display: flex;
  place-content: center;
  align-items: center;
}

.F1 img {
  width: auto;
  height: 10vw;
  margin-right: 1vw;
}

.F1B2 {
  text-align: left;
  line-height: 0.3vw;
}

.F1B2 h3 {
  letter-spacing: 0.001vw;
  color: rgb(41, 38, 38);
  font-weight: 600;
  font-size: 1.6vw;
}

.F1B2 h4 {
  width: 59vw;
  height: auto;
  color: rgb(41, 38, 38);
  font-weight: 500;
  font-size: 1vw;
}

.F1B2 p {
  color: rgb(41, 38, 38);
  font-weight: 600;
  font-size: 1vw;
  margin-bottom: 0.9vw;
}

.F12 {
  display: flex;
  margin-top: 5vw;
  margin-left: 5vw;
}

.DButton {
  cursor: pointer;
  width: 10.156vw;
  height: 2.292vw;
  border: 0px;
  margin-right: 0.072vw;
  font-size: 0.729vw;
  font-weight: 500;
  color: white;
  text-align: center;
  margin-bottom: 1vw;
  background: #007E94;
  margin-top: 2.7083333333333335VW;
}

#ipr {
  visibility: hidden;
}
</style>
